$(() => {
  $('[data-input="clear"]').on("click", (e) => {
    e.preventDefault();
    let target = e.target;
    let textInput = $(target).prev();

    if (textInput.length > 0) {
      $(textInput).val("");
    }
  });
});
